import { useEffect, useRef } from 'react';

const useFavicon = (favicons, isChildSite) => {
  const prevUrlsRef = useRef('');

  useEffect(() => {
    if (!isChildSite) return;
    if (!Array.isArray(favicons) || favicons.length === 0) return;

    const newUrls = favicons.map((f) => f.url).join(',');
    if (newUrls === prevUrlsRef.current) return;
    prevUrlsRef.current = newUrls;

    const head = document.head;
    const existing = Array.from(head.querySelectorAll("link[rel~='icon']"));

    favicons.forEach(({ url, type, size }, i) => {
      let link = existing[i];
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        head.appendChild(link);
      }

      link.href = url;
      if (type) link.type = type;
      if (size) link.sizes = size;
    });

    existing.slice(favicons.length).forEach((el) => el.parentNode.removeChild(el));
  }, [favicons, isChildSite]);
};

export default useFavicon;
